import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react';

import { useEmployee } from '../context/employee';

function EmployeeDropdown({ employeeId, onChange }) {
    const { employees } = useEmployee();

    const [employee, setEmployee] = useState(employeeId || '');

    const employeeOptionTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div className={!option.active ? 'text-red-500' : ''}>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const selectedEmployeeTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div className={!option.active ? 'text-red-500' : ''}>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    useEffect(() => {
        if (employee) {
            onChange(employee);
        }
    }, [employee, onChange]);

    useEffect(() => {
        if (employees.length > 0) {
            setEmployee(employeeId ? employeeId : '');
        }
    }, [employeeId, employees]);

    return (
        <Dropdown
            value={employee}
            valueTemplate={selectedEmployeeTemplate}
            onChange={(e) => setEmployee(e.value)}
            options={employees.sort((a, b) => (a.name > b.name ? 1 : -1))}
            itemTemplate={employeeOptionTemplate}
            optionLabel="name"
            optionValue="_id"
            placeholder="Select an Employee"
        />
    );
}

export default EmployeeDropdown;
